/**
 * @author annie, smk
 * route param, controllers
 */
angular.module('AppCtrl.service', ['AppCtrl.contact.service', 'jv.Common.TemplateLoader', 'jv.Common.Modal', 'jv.Common.Directives.Formtemplate', 'jv.Common.Directives.MessageTemplate']);
angular.module('AppCtrl.directive', ['ui.directives', 'jv.simple-select.directive', 'jv.Common.i18n', 'jv.Common.EmployeeSelect', 'jv.Common.Directives.Datepicker']);

var AppCtrlModule = angular.module('AppCtrl', ['AppCtrl.service', 'AppCtrl.directive', 'AppCtrl.modals', 'AppCtrl.contact.constant', 'JV.Core.Directives', 'jv.Common.Directives.HideOnBlur', 'jv.Common.Directives.LoadingButton', 'jv.Common.EmployeeSelect', 'jv.Common.i18n', 'jv.Common.Directives.Datepicker', 'ngCookies', 'jv.totango', 'jv.Common.Filters', 'ngRoute', 'jv.source.modal-adapter.service']);

AppCtrlModule.config(['$locationProvider', function($locationProvider){
    $locationProvider.hashPrefix('');
}]);
AppCtrlModule.factory('isIE', ['$window', function ($window) {
    if ($window.addEventListener) {
        return false;
    }
    return true;
}]);
AppCtrlModule.factory('addEventListener', ['isIE', function (isIE) {
    var _toAttach = angular.noop,
        _prefix = angular.identity;
    if (!isIE) {
        _toAttach = 'addEventListener';
        _prefix = angular.identity;
    } else {
        _toAttach = 'attachEvent';
        _prefix = function (val) {
            return 'on' + val;
        };
    }

    var _attach = function (val, cb, capture) {
        this[_toAttach](_prefix(val), cb, capture || false);
    };

    return function (el) {
        return angular.bind(el, _attach);
    };
}]);

/// TODO (MikeMac): Refactor this to DRY.
AppCtrlModule.factory('removeEventListener', ['isIE', function (isIE) {
    var _toAttach = angular.noop,
        _prefix = angular.identity;
    if (!isIE) {
        _toAttach = 'removeEventListener';
        _prefix = angular.identity;
    } else {
        _toAttach = 'detachEvent';
        _prefix = function (val) {
            return 'on' + val;
        };
    }

    var _attach = function (val, cb, capture) {
        this[_toAttach](_prefix(val), cb, capture || false);
    };

    return function (el) {
        return angular.bind(el, _attach);
    };
}]);
AppCtrlModule.factory('bindAndUnbindClickToDocument', ['$document', 'addEventListener', 'removeEventListener', function ($document, addEvent, removeEvent) {
    return function bindAndUnbindClickToDocument(el, action) {
        var _doc = $document[0];
        var _outsideHandler = function (ev) {
            action();
            removeEvent(_doc)('click', _outsideHandler, true);
        };
        addEvent(_doc)('click', _outsideHandler, true);
    };
}]);
AppCtrlModule.factory('stopPropagation', ['isIE', function (isIE) {
    if (isIE) {
        return function (event) {
            event.cancelBubble = true;
        };
    } else {
        return function (event) {
            event.stopPropagation();
            event.stopImmediatePropagation();
        };
    }
}]);
AppCtrlModule.factory('addClick', ['bindAndUnbindClickToDocument', 'addEventListener', 'stopPropagation', function (docMagic, addEvent, stopPropagation) {
    return function addClick(el, activate, deactivate) {
        addEvent(el[0])('click', function (ev) {
            docMagic(el, deactivate);
            activate();
            // stopPropagation(ev);
        }, true);
    };
}]);
AppCtrlModule.factory('addMouseover', function () {
    return function addMouseover(el, activate, deactivate) {
        el.bind('mouseover', function () {
            activate();
        });
        el.bind('mouseout', function () {
            deactivate();
        });
    };
});
AppCtrlModule.directive('tooltip', ['$compile', 'addClick', 'addMouseover', 'bindAndUnbindClickToDocument', function ($compile, addClick, addMouseover, docMagic) {
    return {
        replace: true,
        scope: true,
        compile: function (tEl, tAttr) {
            var _trigger = tEl.find('[tooltip-trigger]'),
                trigger = _trigger.html(),
                _title = tEl.find('[tooltip-title]'),
                _title_exists = (_title.length > 0),
                title = _title.html(),
                _body = tEl.find('[tooltip-body]'),
                body = _body.html();
            _trigger.remove();
            _title.remove();
            _body.remove();
            return {
                pre: function (scope, el, attr) {
                    function tooltipAppear() {
                        scope.__showTooltip__ = true;
                    }

                    function tooltipDisappear() {
                        scope.__showTooltip__ = false;
                    }

                    function tooltipAppearWithApply() {
                        scope.$apply(tooltipAppear);
                    }

                    function tooltipDisappearWithApply() {
                        scope.$apply(tooltipDisappear);
                    }

                    var triggerHtml = angular.element(trigger),
                        tooltip = angular.element('<div class=\"tooltipWindow\" ng-show=\"__showTooltip__\"' + (attr.ngAnimate ? ' ng-animate=\"' + attr.ngAnimate + '\"' : '') + '></div>'),
                        tooltipContainer = angular.element('<div class=\"tooltipContainer\"></div>'),
                        titleEl = angular.element('<div class=\"title\">' + title + '</div>'),
                        bodyEl = angular.element('<div class=\"body\">' + body + '</div>'),
                        setEvents = ((angular.isDefined(attr.$attr.showonhover) && attr.$attr.showonhover !== 'false') ? addMouseover : addClick);


                    if (angular.isDefined(attr.show)) {
                        scope.$watch(attr.show, function (newVal) {
                            if (newVal) {
                                docMagic(el, function () {
                                    scope.$parent[attr.show] = false;
                                    tooltipDisappearWithApply();
                                });
                                tooltipAppear();
                            }
                        });
                    }

                    scope.__showTooltip__ = false;
                    el.append($compile(triggerHtml)(scope));
                    if (_title_exists) {
                        tooltipContainer.append(titleEl);
                    }
                    tooltipContainer.append(bodyEl);
                    tooltip.append(tooltipContainer);

                    el.append($compile(tooltip)(scope));
                    el.removeClass('tooltip');

                    setEvents(el, tooltipAppearWithApply, tooltipDisappearWithApply);
                },
                post: angular.noop
            };
        }
    };
}]);
AppCtrlModule.directive('onBlur', function () {
    return {
        restrict: 'A',
        link: function (scope, elm, attrs) {
            elm.on('blur', function () {
                scope.$apply(attrs.onBlur);
            });
        }
    };
});

AppCtrlModule.directive('ngEnter', function () {
    return function (scope, element, attrs) {
        element.bind('keydown keypress', function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngEnter);
                });

                event.preventDefault();
            }
        });
    };
});

AppCtrlModule.factory('createFilter', [
    function () {
        return function (directive) {
            return angular.extend({
                restrict: 'A',
                scope: {
                    filter: '=',
                    filterModel: '=',
                    onSummaryChanged: '&',
                    onFilterLoaded: '&'
                }
            }, directive);
        };
    }
]);
AppCtrlModule.factory('createDropdownLinker', [
    '$timeout', 'i18n',
    function ($timeout, i18n) {
        return function () {
            return function (scope, element) {
                function updateSummary(val) {
                    if (scope.filter.clear) {
                        var deleted = false;
                    } else {
                        deleted = !val;
                    }
                    var summary = {
                        deleted: deleted
                    };
                    summary.message = scope.filter.label + ': ' + val;
                    scope.onSummaryChanged({
                        summary: summary
                    });
                }

                function setDefaultValue(force) {
                    if (force || (scope.filter.defaultValue != null && !scope.filterModel)) {
                        scope.filterModel = scope.filter.defaultValue;
                    }
                }

                scope.$watch('filterModel', function (val, oldVal) {
                    if (val === null && oldVal) {
                        scope.filter.clear = true;
                    }
                    updateSummary(val);
                });

                scope.$on('resetFilter', function () {
                    $timeout(function () {
                        setDefaultValue(true);
                    });
                });

                scope.onFilterLoaded();
            };
        };
    }
]);
AppCtrlModule.directive('jvDropdownFilter', [
    'createFilter', 'createDropdownLinker', 'i18n',
    function (createFilter, createDropdownLinker, i18n) {
        return createFilter({
            link: createDropdownLinker(),
            template: '<select simple-select="{ allowClear: true, placeholder: \'' + i18n.ANY + '\' }" ng-model="filterModel" class="full-width" ng-options="o.key as o.value for o in filter.valueArray"><option></option></select>'
        });
    }
]);
AppCtrlModule.directive('jvCheckboxFilter', [
    'createFilter', 'i18n',
    function (createFilter, i18n) {
        return createFilter({
            link: function (scope) {
                var AMOUNT_VISIBLE = 4;
                scope.i18n = i18n;
                scope.state = {
                    amountVisible: AMOUNT_VISIBLE,
                    enableShowMore: scope.filter.valueArray.length > AMOUNT_VISIBLE,
                    showingMore: false
                };

                function isEmpty() {
                    return scope.filter.valueArray.every(function (value) {
                        return !scope.filterModel[value.key];
                    });
                }

                function updateSummary() {
                    var summary = {
                        deleted: scope.isEmpty
                    };
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ' + scope.filter.valueArray.filter(function (value) {
                            return scope.filterModel[value.key];
                        }).map(function (value) {
                            return value.value;
                        }).join(', ');
                    }
                    if (scope.filter.clear) {
                        summary.deleted = false;
                    }
                    scope.onSummaryChanged({
                        summary: summary
                    });
                }

                scope.toggleAmount = function () {
                    scope.state.showingMore = !scope.state.showingMore;
                    if (scope.state.showingMore) {
                        scope.state.amountVisible = scope.filter.valueArray.length;
                    } else {
                        scope.state.amountVisible = AMOUNT_VISIBLE;
                    }
                };

                scope.$watch('filterModel', function (val, oldVal) {
                    if (oldVal) {
                        scope.filter.clear = true;
                    }
                    if (!val) {
                        scope.filterModel = {};
                    }
                    scope.isEmpty = isEmpty();
                    scope.state.any = scope.isEmpty;
                    updateSummary();
                }, true);
                scope.$watch('state.any', function (any) {
                    if (any) {
                        // reset selected
                        scope.filter.valueArray.forEach(function (value) {
                            scope.filterModel[value.key] = false;
                        });
                    }
                });
                scope.onFilterLoaded();
            },
            template: '<div class="jv-checkbox-filter-group"><div class="margin-bottom-xx-small"><label><input type="checkbox" ng-model="state.any" ng-disabled="isEmpty" /> {{ i18n.ANY }}</label></div><div ng-repeat="value in filter.valueArray | limitTo:state.amountVisible" class="margin-bottom-xx-small"><label><input type="checkbox" ng-model="filterModel[value.key]" value="1" /> {{ value.value }}</label></div><a href="" class="display-block" ng-if="state.enableShowMore" ng-click="toggleAmount()">{{ state.showingMore ? i18n.SHOW_LESS : i18n.SHOW_ALL }}</a></div>'
        });
    }
]);
AppCtrlModule.factory('jvNumberRangeFilterTagFAC', [function () {
    return function () {
        return '<div class="row"><div class="col-6 padding-none" ng-repeat="field in custom"><label class="block dark-tri">{{ field.label }}</label><input type="number" class="full-width" ng-model="filterModel[field.model]" /></div>';
    };
}]);
AppCtrlModule.directive('jvNumberRangeFilter', [
    'createFilter', 'i18n', 'jvNumberRangeFilterTagFAC',
    function (createFilter, i18n, jvNumberRangeFilterTagFAC) {
        return createFilter({
            link: function (scope) {
                scope.filterModel = scope.filterModel || {};

                function updateSummary(val) {
                    var summary = {
                        deleted: scope.filterModel.minValue == null || scope.filterModel.maxValue == null
                    };
                    if (!summary.deleted) {
                        summary.message = scope.filterModel.minValue + ' - ' + scope.filterModel.maxValue;
                    }
                    scope.onSummaryChanged({
                        summary: summary
                    });
                }

                scope.custom = [{
                        model: 'minValue',
                        label: i18n.MIN
                    },
                    {
                        model: 'maxValue',
                        label: i18n.MAX
                    }
                ];
                scope.$watch('filterModel', updateSummary, true);
                scope.onFilterLoaded();
            },
            template: jvNumberRangeFilterTagFAC()
        });
    }
]);
AppCtrlModule.factory('currencyAjaxSelectTagFAC', [function () {
    return function (url, ngModel, placeholder) {
        return '<div jv-ajax-select jv-ajax-select-id="currencyCode" jv-ajax-select-no-pagination="false" jv-ajax-select-url="{0}" jv-ajax-select-response-key="resultList" jv-ajax-select-text="displayName" jv-ajax-select-query-param-name="q" ng-model="{1}" jv-ajax-select-can-clear="true" jv-ajax-select-populate class="margin-bottom-xx-small full-width" jv-ajax-select-placeholder="{2}"></div>'.format(url, ngModel, placeholder);
    };
}]);
AppCtrlModule.directive('jvCurrencyRangeFilter', ['createFilter', 'i18n', 'currencyAjaxSelectTagFAC', 'jvNumberRangeFilterTagFAC', '$compile',
    function (createFilter, i18n, currencyAjaxSelectTagFAC, jvNumberRangeFilterTagFAC, $compile) {
        return createFilter({
            link: function (scope, elem, attrs, ngModel) {
                scope.filterModel = scope.filterModel || {};
                scope.custom = [{
                        model: 'minValue',
                        label: i18n.MIN
                    },
                    {
                        model: 'maxValue',
                        label: i18n.MAX
                    }
                ];

                function isEmpty(val) {
                    return angular.isUndefined(val) || val === '';
                }

                function getFilterChange(val) {
                    var summary = {
                        deleted: isEmpty(val.minValue) || isEmpty(val.maxValue) || isEmpty(val.currency)
                    };
                    if (!summary.deleted) {
                        summary.message = '{0}: {1} - {2}'.format(val.currency, val.minValue, val.maxValue);
                    }
                    return {
                        summary: summary
                    };
                }

                function getTemplate(url, model, placeholder) {
                    return '<div>{0}{1}</div>'.format(
                        currencyAjaxSelectTagFAC(url, model, placeholder),
                        jvNumberRangeFilterTagFAC()
                    );
                }

                scope.$watch('filterModel', function (val) {
                    scope.onSummaryChanged(getFilterChange(val));
                }, true);

                elem.append($compile(getTemplate(attrs.currencyDataUrl, "filterModel['currency']", i18n.SELECT_CURRENCY))(scope));
            }
        });
    }
]);
AppCtrlModule.directive('jvEmployeeFilter', [
    'createFilter', 'i18n',
    function (createFilter, i18n) {
        return createFilter({
            link: function (scope) {
                scope.i18n = i18n;

                function updateSummary(val) {
                    var summary = {
                        deleted: !val || !val.length
                    };
                    if (!summary.deleted) {
                        summary.message = val;
                    }
                    if (scope.clear) {
                        summary.deleted = false;
                    }
                    scope.onSummaryChanged({
                        summary: summary
                    });
                }

                scope.$watch('filterModel', function (val, oldVal) {
                    if (oldVal) {
                        scope.clear = true;
                    }
                    updateSummary(val);
                });

                scope.onFilterLoaded();
            },
            template: '<input jv-employee-select="multiple" ng-model="filterModel" type="hidden" jv-employee-select-obj style="width:100%" />'
        });
    }
]);
AppCtrlModule.directive('jvDateRangeFilter', [
    'createFilter', 'i18n', '$rootScope', '$filter', '$timeout',
    function (createFilter, i18n, $rootScope, $filter, $timeout) {
        return createFilter({
            link: function (scope, element) {
                var saveFormat = 'YYYY-MM-DD';
                scope.types = [{
                        value: 1,
                        label: i18n.PAST_7_DAYS
                    },
                    {
                        value: 2,
                        label: i18n.PAST_MONTH
                    },
                    {
                        value: 3,
                        label: i18n.PAST_3_MONTHS
                    },
                    {
                        value: 'custom',
                        label: i18n.CUSTOM_RANGE
                    }
                ];
                scope.custom = [{
                        model: 'from',
                        label: i18n.FROM,
                        datepicker: {
                            onClose: function () {
                                $timeout(function () {
                                    // timeout for datepicker, without this it will
                                    // not update first field on blur
                                    if (!scope.filterModel.to) {
                                        element.find('[jv-locale-datepicker]')[1].focus();
                                    }
                                }, 200, false);
                            }
                        }
                    },
                    {
                        model: 'to',
                        label: i18n.TO,
                        datepicker: {}
                    }
                ];

                function updateSummary(val) {
                    var summary = {
                        deleted: !val || !scope.filterModel.from || !scope.filterModel.to
                    };
                    if (!summary.deleted) {
                        summary.message = scope.filter.name + ': ';
                        if (val.type === 'custom') {
                            summary.message += $filter('localeDateTime')(scope.filterModel.from, 'shortDate', 'MM/dd/yyyy', true) + ' - ' + $filter('localeDateTime')(scope.filterModel.to, 'shortDate', 'MM/dd/yyyy', true);
                        } else {
                            summary.message += scope.types.filter(function (type) {
                                return (scope.filterModel.type === type.value);
                            }).pop().label;
                        }
                        summary.val = val;
                    }
                    if (scope.filter.clear) {
                        summary.deleted = false;
                    }
                    scope.onSummaryChanged({
                        summary: summary
                    });
                }

                function fetchTodayInUsersTimeZone() {
                    var userTimeZone = _jvselfUser.locale.timezone;
                    var todayDate = new Date(moment.tz(new Date(), userTimeZone).format('MM/DD/YYYY'));
                    return todayDate;
                }

                function getDateRange(type) {
                    var today = fetchTodayInUsersTimeZone();
                    var range = {
                        to: moment(today).format(saveFormat)
                    };
                    switch (type) {
                        case 1:
                            range.from = moment(today).subtract(6, 'days').format(saveFormat);
                            break;
                        case 2:
                            range.from = moment(today).subtract(29, 'days').format(saveFormat);
                            break;
                        case 3:
                            range.from = moment(today).subtract(89, 'days').format(saveFormat);
                            break;
                        default:
                            // default
                    }
                    return range;
                }

                scope.showRangePicker = function () {
                    if (!scope.filterModel) {
                        return;
                    }
                    return (scope.filterModel.type === 'custom');
                };

                scope.handleUserTypeChange = function () {
                    var dateRange;
                    if (scope.filterModel.type === 'custom') {
                        scope.filterModel.from = moment(fetchTodayInUsersTimeZone()).format(saveFormat);
                        scope.filterModel.to = null;
                        $timeout(function () {
                            // timeout for datepicker, without this it will
                            // change the second field instead of the first
                            element.find('[jv-locale-datepicker]')[0].focus();
                        }, 10);
                    } else if (scope.filterModel.type) {
                        dateRange = getDateRange(scope.filterModel.type);
                        scope.filterModel.to = dateRange.to;
                        scope.filterModel.from = dateRange.from;
                    }
                };

                // Due to the way facets are reloaded, we can't autopopulate the second value.
                // Doing so causes the datepicker to become misaligned.
                // Leaving this here so we know when refactoring, this change should be configurable.

                // scope.handleFieldFocus = function(field) {
                //     if (field.model === 'to' && scope.filterModel.from && !scope.filterModel.to) {
                //         scope.filterModel.to = scope.filterModel.from;
                //     }
                // };

                scope.$watch('filterModel.type', function (val, oldVal) {
                    if (val === null && oldVal) {
                        scope.filter.clear = true;
                    }
                    if (scope.filterModel && val == null) {
                        scope.filterModel.from = null;
                        scope.filterModel.to = null;
                    }
                });
                scope.$watch('filterModel.from', function (val) {
                    // prevent user from selecting earlier 'to' date
                    if (val) {
                        scope.custom[1].datepicker.minDate = moment(val, saveFormat).toDate();
                    } else {
                        scope.custom[1].datepicker.minDate = null;
                    }
                });
                scope.$watch('filterModel.to', function (val) {
                    // prevent user from selecting later 'from' date
                    if (val) {
                        scope.custom[0].datepicker.maxDate = moment(val, saveFormat).toDate();
                    } else {
                        scope.custom[0].datepicker.maxDate = null;
                    }
                });
                scope.$watch('filterModel', updateSummary, true);
                scope.onFilterLoaded();
            },
            template: '<select simple-select="{ allowClear: true, placeholder: \'' + i18n.ANY + '\' }" ng-model="filterModel.type" ng-options="o.value as o.label for o in types" class="full-width" ng-change="handleUserTypeChange()"><option></option></select>' +
                '<div ng-show="showRangePicker()" class="margin-top-x-small row">' +
                '<div class="col-6 padding-none" ng-repeat="field in custom">' +
                '<label class="block dark-tri">{{ field.label }}</label>' +
                '<input type="text" jv-locale-datepicker="field.datepicker" class="full-width" ng-model="filterModel[field.model]" ng-focus="handleFieldFocus(field)" />' +
                '</div>' +
                '</div>'
        });
    }
]);
AppCtrlModule.directive('jvLocationAutoComplete', function () {
    return {
        compile: function (tElm, tAttrs) {
            var geo = new google.maps.Geocoder();

            return function (scope, elm, attrs, controller) {
                (elm).autocomplete({
                    autoFocus: true,
                    source: function (request, response) {
                        geo.geocode({
                            'address': request.term
                        }, function (LocObj, status) {
                            response($.map(LocObj, function (item) {
                                return {
                                    label: item.formatted_address,
                                    value: item.formatted_address,
                                    geoObj: item
                                };
                            }));
                        });
                    },
                    minLength: 3,
                    open: function (elem) {
                        var autoBox = $('ul.ui-autocomplete');
                        var pos = $(elm).offset();
                        $(autoBox).css('z-index', 10000);
                        $(autoBox).css('top', pos.top + 25 + 'px');
                        $(autoBox).css('left', pos.left + 'px');
                        $(autoBox).css('width', (elm).outerWidth() - 6 + 'px');
                    },
                    select: function (event, ui) {
                        scope.l = ui.item.value;
                        if (ui.item.geoObj.geometry.location.lng()) {
                            scope.longitude = ui.item.geoObj.geometry.location.lng();
                        }
                        if (ui.item.geoObj.geometry.location.lat()) {
                            scope.latitude = ui.item.geoObj.geometry.location.lat();
                        }
                        scope.$apply(function () {
                            scope.userSearch('l');
                        });
                    },
                    focus: function (event, ui) {
                        scope.l = ui.item.value;
                        if (ui.item.geoObj.geometry.location.lng()) {
                            scope.longitude = ui.item.geoObj.geometry.location.lng();
                        }
                        if (ui.item.geoObj.geometry.location.lat()) {
                            scope.latitude = ui.item.geoObj.geometry.location.lat();
                        }
                    }
                });
            };
        }
    };
});

AppCtrlModule.service('ModuleService', function () {
    this.value = 'ModuleService.Value value';
    this.page = 0;
    this.sort = 12;
});
AppCtrlModule.service('FacetMapService', function () {
    this.facetMap = {};
});

//functions for URL param manipulation (stored in a hashmap)

//turns the appropriate values in facetMap into a URL param
function params(facetService) {
    var map = facetService.facetMap;
    var open = facetService.openFacetFields;
    var params = [];
    var location = facetService.l || '';
    var keywords = facetService.kw || '';
    var latitude = facetService.latitude || '';
    var longitude = facetService.longitude || '';
    var maxResults = facetService.maxResults && facetService.maxResults.trim() || '';

    params.push('kw=' + keywords + '$' + facetService.searchNameOnly);
    if (location !== '') {
        params.push('l=' + location);
    }
    if (latitude && longitude) {
        params.push('lat=' + latitude);
        params.push('long=' + longitude);
    }
    //console.log(map);
    for (var key in map) {
        if (key !== 'kw' && key !== 'l') {
            //console.log(key+' contains '+map[key].values);
            if (map[key].values.length === 1) params.push(key + '=' + map[key].values[0]);
            else {
                //using $ instead of a comma because some company names may contain commas.
                params.push(key + '=' + map[key].values.join('$'));
            }
        }
    }
    //console.log(params);
    var urlParams = params.join('-|-') + '-||-' + open.join('-|-') + '-||-' + facetService.sort + '-||-' + facetService.page;
    if (maxResults !== '') {
        urlParams += '-||-' + maxResults;
    }
    return urlParams;
}

//for when checkboxes are checked (facetValues)
function addFacet(map, checkedCategory, checkedValue) {
    var categoryExists = checkedCategory in map.facetMap;
    if (map.length == 0 || !categoryExists) {
        map.facetMap[checkedCategory] = {};
        map.facetMap[checkedCategory].values = [];
        map.facetMap[checkedCategory].values[0] = checkedValue;
        map.facetMap[checkedCategory].more = false;
        map.length++;
    } else {
        if ($.inArray(checkedValue, map.facetMap[checkedCategory].values) !== -1) {
            removeValue(map.facetMap, checkedCategory, checkedValue);
        } else {
            addValue(map.facetMap[checkedCategory].values, checkedValue);
        }
    }
}

function addValue(list, value) {
    list[list.length] = value; //TODO: escape commas.
}

function removeValue(map, list, value) {
    if (map[list].values.length === 1) {
        delete map[list];
        //map['length']--;
    } else {
        map[list].values.splice(map[list].values.indexOf(value), 1);
    }
}

//whenever there are changes, this method will update the object.
function updateFacetMap(FacetMapService, urlPath) {
    var stringPath = urlPath[1];
    var openFacetPath = urlPath[2];
    var sortPath = urlPath[3];
    var pagePath = urlPath[4];
    var maxResultsPath = urlPath[5] && urlPath[5].trim();

    FacetMapService.facetMap = {};
    FacetMapService.kw = '';
    FacetMapService.l = '';
    FacetMapService.searchNameOnly = false;
    FacetMapService.sortMapping = sortFilters;
    FacetMapService.sort = '12';
    FacetMapService.page = 0;
    FacetMapService.length = 0;
    FacetMapService.latitude = '';
    FacetMapService.longitude = '';

    // console.log(stringPath);
    if (!(stringPath === '' || stringPath === undefined)) {
        var facetArray = stringPath.split('-|-');
        var noLocationRadius = true;
        //FacetMapService.openFacetFields = [];
        angular.forEach(facetArray, function (value, key) {
            //EN-3972: Here we have to consider only first '=' sign and split 'value' as there can be a use case where the collection name contains '='. 
            var index = value.indexOf('=');
            var category = index >= 0 ? value.substring(0, index) : value;
            var catValues = index >= 0 ? value.substring(index + 1, value.length) : '';

            if (category === 'l') {
                FacetMapService.l = catValues;
                //console.log(catValues);
            } else if (catValues && catValues.trim() !== '' && category === 'lat') {
                FacetMapService.latitude = catValues;
            } else if (catValues && catValues.trim() !== '' && category === 'long') {
                FacetMapService.longitude = catValues;
            } else if (category === 'kw') {
                var valueList = catValues.split('$');
                FacetMapService.kw = valueList[0];
                FacetMapService.searchNameOnly = valueList[1] === 'true';
            } else {
                if (category && typeof catValues === 'undefined') {
                    var valueList = value.split('$');
                    FacetMapService.kw += '&' + valueList[0];
                    FacetMapService.searchNameOnly = valueList[1] === 'true';
                }
                if (category === 'lv') noLocationRadius = false;
                var valueList = catValues ? catValues.split('$') : value.split('$');

                //FacetMapService.openFacetFields.push(category);
                FacetMapService.facetMap[category] = {};
                FacetMapService.facetMap[category].values = valueList;
                FacetMapService.facetMap[category].open = true;
                FacetMapService.facetMap[category].checked = false;
                FacetMapService.length++;
                // console.log(category + ': ' + valueList);
            }
        });

        // if (noLocationRadius) FacetMapService.l = '';
    }
    if (!(openFacetPath === '' || openFacetPath === undefined)) {
        FacetMapService.openFacetFields = openFacetPath.split('-|-');
    }
    if (!(sortPath === '' || sortPath === undefined)) {
        FacetMapService.sort = sortPath;
        if (sortPath === '13') {
            sortFilters['13'] = {
                'text': 'Relevance',
                'key': '-relevance'
            };
        }
    }
    if (!(pagePath === '' || pagePath === undefined)) {
        FacetMapService.page = pagePath;
        //console.log(pagePath);
    }
    if (maxResultsPath !== '') {
        FacetMapService.maxResults = maxResultsPath;
    }
}

/**
If contacts is part of an iframe then call this function so that it adjust the height of the contacts
*/
function resizeIfIframe() {
    var intervalHeight = setInterval(function () {
        if (top === self) {
            clearInterval(intervalHeight);
        } else {
            try {
                parent.adjustContactsHeight($('body').height());
                $('#jv-campaigns').css('zoom', 'normal');
            } catch (e) {}
        }
    }, 300);
}

//sort dropdown
var sortFilters = {
    '01': {
        'text': i18n['JV_CONTACTLIST_NAME'],
        'key': 'name'
    },
    // '02': {'text':'Name (Z to A)','key':'-name'},
    // '03': {'text':'Company Name','key':'companyname'},
    // '04': {'text':'Company Name Desc','key':'-companyname'},
    // '05': {'text':'Title','key':'title'},
    // '06': {'text':'Title Desc','key':'-title'},
    // '07': {'text':'Distance','key':'distance'},
    // '08': {'text':'Distance Desc','key':'-distance'},
    // '09': {'text':'Email','key':'email'},
    // '10': {'text':'Email Desc','key':'-email'},
    '11': {
        'text': i18n['JV_CONTACTLIST_ACTIVITY_OLDEST'],
        'key': 'updatedate'
    },
    '12': {
        'text': i18n['JV_CONTACTLIST_ACTIVITY_RECENT'],
        'key': '-updatedate'
    }
    //'13': {'text':'Relevance', 'key' :'-relevance'}
    // '14': {'text':'Relevance (theotherone)', 'key' :'relevance'},
};


//sort dropdown
var maxResultsFilters = {
    '1': {
        'text': '50'
    },
    '2': {
        'text': '100'
    },
    '3': {
        'text': '250'
    },
    '4': {
        'text': '500'
    }
};

//action dropdown

var actionFilters = [{
        text: i18n['JV_CONTACTLIST_ADD_TO_CAMPAIGN'],
        key: 'campaign'
    },
    {
        text: i18n['JV_CONTACTLIST_ADD_NOTE'],
        key: 'note'
    },
    {
        text: i18n['JV_CONTACTLIST_ADD_TASK'],
        key: 'task'
    },
    {
        text: i18n['JV_CONTACTLIST_ADD_TAG'],
        key: 'tag'
    },
    {
        text: i18n['JV_CONTACTLIST_ASSIGN_TO'],
        key: 'assign'
    },
    {
        text: i18n['JV_CONTACTLIST_CHANGE_STATUS'],
        key: 'status'
    },
    {
        text: i18n['JV_CONTACTLIST_MERGE_CONTACTS'],
        key: 'merge'
    },
    {
        text: i18n['JV_CONTACTLIST_SEND_MESSAGE'],
        key: 'message'
    },
    {
        text: i18n['JV_CONTACTLIST_SEND_JOBVITE'],
        key: 'jobvite'
    }
];

// add Seek Consent dropdown action only if gdpr and contact consent form is enabled
if (JV.gdprEnabled === 'true' && JV.consentFormEnabled === 'true') {
    actionFilters.push({
        text: i18n['SEEK_CONSENT'],
        key: 'seekConsent'
    });
}

// adding to action dropdown list
actionFilters.push({
    text: i18n['JV_CONTACTLIST_EXPORT'],
    key: 'export'
});
actionFilters.push({
    text: i18n['JV_CONTACTLIST_DELETE'],
    key: 'delete'
});

if (!!JV.engageAndAtsEnabled && JV.engageAndAtsEnabled === 'true' && JV.isRecruiter === 'true' && JV.hasAccessToAddToReq === 'true') {
    actionFilters.push({
        text: i18n['JV_CONTACTLIST_ADD_TO_REQUISITION'],
        key: 'addContactsToReqs'
    });
}

/*************************************************************/
/******************** Controllers ****************************/
/*************************************************************/
AppCtrlModule.controller('ContactCtrl', ['$scope', '$rootScope', '$document', 'contactService', 'FacetMapService', '$location', 'modalService', '$timeout',
    function ($scope, $rootScope, $document, contactService, FacetMapService, $location, modalService, $timeout) {
        // var stringPath = null;
        // Make it as part of the root Controller, so its available to everyone.
        $scope.i18n = i18n || {};
        $scope.mapView = {
            show: true
        };
        $scope.filter = {};
        if (JV && JV.gdprEnabled === 'true') {
            $scope.gdprEnabled = true;
        }
        if (window.isnextGenUIEnabled==='true' && window.self === window.top) {
            document.getElementsByTagName('body')[0].classList.add('jv-pipeline-contacts-container');
        } else {
            document.getElementsByTagName('body')[0].classList.add('jv-campaign-contacts-container');
        }

        updateFacetMap(FacetMapService, $location.path().split('-||-'));

        //import contacts
        $scope.importContacts = function () {
            modalService.importContacts();
        };

        $scope.jvUrls = jvUrls;
        // click event broadcast
        $document.on('click', function (event) {
            $timeout(function () {
                $rootScope.$broadcast('closeDropDown');
            });
        });

        $scope.showPageLoading = function () {
            JV.showFullPageLoading();
        };

        $scope.removePageLoading = function () {
            JV.removeFullPageLoading();
        };
        $scope.$on('totalCount', function (event, data) {
            $scope.total = data;
        });
        $scope.$on('filter', function (event, data) {
            $scope.filter = data;
        });
        $scope.showAnonymizedContactsCount = function () {
            var filters = angular.extend({}, $scope.filter, {
                anonymized: true
            });
            contactService.getContactsCount(filters, function (results) {
                $scope.getAnonymizedContactsCount = results.data.contactsCount;
            });
        };
        $scope.hideAnonymizedCount = function () {
            $scope.showtooltip = false;
        };
        resizeIfIframe();
    }
]);

/**
 * Grid Filter Controller
 */
AppCtrlModule.controller('ContactFilterCtrl', ['$rootScope', '$scope', 'closeFilter', 'openFilter', 'contactService', 'FacetMapService', 'logService', '$location', 'modalService', 'constantService', '$cookies', 'jvTotango', '$filter',
    function ($rootScope, $scope, closeFilter, openFilter, contactService, FacetMapService, logService, $location, modalService, constantService, $cookies, jvTotango, $filter) {
        var filterCookie = 'cf';
        $scope.enableCustomFieldSearch = window.JV.enableCustomFieldSearch;
        $scope.andFacets = {
            facets: []
        };
        $scope.dataConsentStatusField = {};
        $scope.dataConsentDateField = {};
        $scope.autoDeletionDateField = {};
        if (window.JV && window.JV.gdprEnabled === 'true') {
            $scope.gdprEnabled = true;
        }
        if (window.JV && window.JV.consentFormEnabled === 'true') {
            $scope.consentFormEnabled = true;
        }

        $scope.onSummaryChanged = function (summary) {
            if (!summary.deleted) {
                $scope.userSearch('custom');
            }
        };

        $scope.onFilterChanged = function (summary) {
            if (!summary.deleted) {
                $scope.userSearch('filter');
            }
        };

        // calculate the number of facet values shown when clicking More and Less.  Note the special logic to show 10 tags per page instead of 5
        $scope.pageSize = function (categoryId) {
            return categoryId === 't' ? constantService.FACET_PAGE_SIZE * 2 : constantService.FACET_PAGE_SIZE;
        };

        $scope.page2Size = function (categoryId) {
            return $scope.pageSize(categoryId) * 2;
        };

        var setPathWithKeyword = function (path) {
            if (!!path) {
                var keyword = path.split('queryString=')[1];
                /*Even after removing from here, cookie was existent*/
                //$cookies.remove(filterCookie);
                $location.path('/#/-||-kw=' + decodeURIComponent(keyword).trim() + '$false-||-cc-|-cs-||-13-||-0');
            }
        };

        /* Here we are testing if the contact list page is being loaded in an iframe and if the iframe source contains ck=false,
         * In the case when ck=false, we return false as we do not intend to use the cookie.
         * Currently ck=false is set for 'Add Contacts' tab in email campaigns.
         */
        var useCookie = function () {
            if (window && window.frameElement && window.frameElement.src && window.frameElement.src.indexOf('ck=false') !== -1) {
                return false;
            }
            return true;
        };

        if ($location.path().indexOf('queryString') !== -1) {
            setPathWithKeyword($location.path());
        } else if ($cookies.get(filterCookie) && useCookie()) {
            $location.path($cookies.get(filterCookie));
        }

        $scope.locationResults = [];

        var resetComplianceFilters = function () {
            if (FacetMapService) {
                FacetMapService.dataConsentStatus = '';
                FacetMapService.consentDateFrom = '';
                FacetMapService.consentDateTo = '';
                FacetMapService.autoDeletionDateFrom = '';
                FacetMapService.autoDeletionDateTo = '';
            }
        };

        var convertDateFormat = function (date) {
            if (date) {
                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            }
        };

        var addComplianceFilters = function () {
            if (FacetMapService) {
                if ($scope.dataConsentStatusField && $scope.dataConsentStatusField.selectedValue) {
                    FacetMapService.dataConsentStatus = $scope.dataConsentStatusField.selectedValue;
                }

                if ($scope.dataConsentDateField && $scope.dataConsentDateField.selectedValue && $scope.dataConsentDateField.selectedValue.from && $scope.dataConsentDateField.selectedValue.to) {
                    FacetMapService.consentDateFrom = convertDateFormat($scope.dataConsentDateField.selectedValue.from);
                    FacetMapService.consentDateTo = convertDateFormat($scope.dataConsentDateField.selectedValue.to);
                }

                if ($scope.autoDeletionDateField && $scope.autoDeletionDateField.selectedValue && $scope.autoDeletionDateField.selectedValue.from && $scope.autoDeletionDateField.selectedValue.to) {
                    FacetMapService.autoDeletionDateFrom = convertDateFormat($scope.autoDeletionDateField.selectedValue.from);
                    FacetMapService.autoDeletionDateTo = convertDateFormat($scope.autoDeletionDateField.selectedValue.to);
                }
            }
        };


        $scope.makeSearchCall = function () {
            $scope.initialDisable = false;
            updateFacetMap(FacetMapService, $location.path().split('-||-'));
            if ($scope.mapView && $scope.mapView.show) {
                FacetMapService.maxResult = 100;
            }
            delete FacetMapService.custom;
            FacetMapService.customFiltersString = [];
            if ($scope.gdprEnabled) {
                resetComplianceFilters();
            }
            if ($scope.customFields && !$scope.resetSearch) {
                angular.forEach($scope.customFields, function (customField, key) {
                    if ((customField.type === 'Text' || customField.type === 'Select' || customField.type === 'Textarea' || customField.type === 'Amount') && customField.selectedValue && customField.selectedValue.trim() !== '') {
                        var value = customField.selectedValue && customField.selectedValue.trim();
                        if (customField.type === 'Select') {
                            /*
                             * We are constructing the key and value pairs in the UI for Select and Radio custom field types. 
                             * This data is user entered text and there was a bug happening when the key was starting with a '$' symbol
                             * as this won't trigger the watch which in turn would make the search call with this custom field value.
                             * As a workaround, we are appending all the key names with this text: 'remove'
                             * And before making the search call, we are removing the added text.
                             * Refer to: https://jobvite.atlassian.net/browse/EN-3349
                             */
                            value = value.replace('remove', '');
                        }
                        FacetMapService.customFiltersString.push({
                            'fieldId': customField.id,
                            'values': [value]
                        });
                    } else if ((customField.type === 'Radio' || customField.type === 'Check') && customField.selectedValue) {
                        var selectedValArray = [];
                        angular.forEach(customField.selectedValue, function (value, key) {
                            if (value && key) {
                                if (customField.type === 'Radio') {
                                    /*
                                     * We are constructing the key and value pairs in the UI for Select and Radio custom field types. 
                                     * This data is user entered text and there was a bug happening when the key was starting with a '$' symbol
                                     * as this won't trigger the watch which in turn would make the search call with this custom field value.
                                     * As a workaround, we are appending all the key names with this text: 'remove'
                                     * And before making the search call, we are removing the added text.
                                     * Refer to: https://jobvite.atlassian.net/browse/EN-3349
                                     */
                                    selectedValArray.push(key.replace('remove', ''));
                                } else {
                                    selectedValArray.push(key);
                                }
                            }
                        });
                        if (selectedValArray && selectedValArray.length > 0) {
                            FacetMapService.customFiltersString.push({
                                'fieldId': customField.id,
                                'values': selectedValArray
                            });
                        }
                    } else if ((customField.type === 'Employee') && customField.selectedValue) {
                        var selectedValArray = [];
                        angular.forEach(customField.selectedValue, function (value, key) {
                            if (value.fullName) {
                                selectedValArray.push(value.fullName);
                            }
                        });
                        if (selectedValArray && selectedValArray.length > 0) {
                            FacetMapService.customFiltersString.push({
                                'fieldId': customField.id,
                                'values': selectedValArray
                            });
                        }
                    } else if ((customField.type === 'Date') && customField.selectedValue && customField.selectedValue.from && customField.selectedValue.to) {
                        FacetMapService.customFiltersString.push({
                            'fieldId': customField.id,
                            'minValue': customField.selectedValue.from,
                            'maxValue': customField.selectedValue.to,
                        });
                    } else if ((customField.type === 'Number' || customField.type === 'Currency') &&
                    customField.selectedValue && customField.selectedValue.minValue &&
                    customField.selectedValue.minValue !== '' && customField.selectedValue.maxValue && customField.selectedValue.maxValue !== '') {
                        var params = {
                            'fieldId': customField.id,
                            'minValue': customField.selectedValue.minValue,
                            'maxValue': customField.selectedValue.maxValue,
                        };
                        if (customField.type === 'Currency' && !!customField.selectedValue.currency) {
                            params.unitOfMeasure = customField.selectedValue.currency;
                            FacetMapService.customFiltersString.push(params);
                        } else if (customField.type === 'Number') {
                            FacetMapService.customFiltersString.push(params);
                        }
                    }
                });
            }
            if ($scope.gdprEnabled) {
                addComplianceFilters();
            }
            contactService.getMapping(FacetMapService, function () {
                $scope.$emit('filter', FacetMapService);
                contactService.searchContacts(FacetMapService);
            });
            if (useCookie()) {
                $cookies.put(filterCookie, $location.path());
            }
        };



        //watching for the change in location make ajax call everytime url changes
        //this will account for both checkboxes and history moves
        $scope.$watch(function () {
            return $location.path();
        }, function () {
            if ($location.path() === '/' || $location.path() === '' || $location.path() === '//') {
                //Need to add page loading image 
                $scope.initialDisable = true;
                updateFacetMap(FacetMapService, '/');
                if ($scope.mapView && $scope.mapView.show) {
                    FacetMapService.maxResult = 100;
                }
                contactService.pagesCacher = {};
                contactService.initialize(null, null);
                //VA: for caching next call.
                updateFacetMap(FacetMapService, $location.path().split('/'));
                contactService.getPreviousNextPages({}, [1]);
                if (useCookie()) {
                    $cookies.remove(filterCookie);
                }
            } else {
                $scope.makeSearchCall();
            }
        }, true);



        //keyword and location
        $scope.userSearch = function (type) {
            if (FacetMapService[type] !== $scope[type] || FacetMapService.searchNameOnly !== $scope.searchNameOnly || type === 'custom' || type === 'filter') {
                $rootScope.$broadcast('showBodyLoading');
                jvTotango.track('Search', jvTotango.module.pipeline);
                FacetMapService.longitude = $scope.longitude;
                FacetMapService.latitude = $scope.latitude;
                FacetMapService[type] = $scope[type];
                if ($rootScope.mapEnable) {
                    FacetMapService.maxResults = 500;
                }
                if (type === 'l' && ($.inArray('lv', FacetMapService.openFacetFields) === -1)) {
                    FacetMapService.openFacetFields.push('lv');
                    FacetMapService.facetMap['lv'] = {};
                    FacetMapService.facetMap['lv'].values = ['0-5'];
                } else {
                    FacetMapService.sort = '13';
                    //google analytics
                    sortFilters['13'] = {
                        'text': 'Relevance',
                        'key': '-relevance'
                    };
                    if (typeof _gaq !== 'undefined') {
                        _gaq.push(['_trackEvent', JV.PAGE_TYPE, 'facetedSearch-kwSearch: ' + $scope[type], _jvselfUser.companyEId]);
                    }
                }
                FacetMapService.page = 0;
                FacetMapService.searchNameOnly = $scope.searchNameOnly;
                if ($rootScope._map) {
                    //                  $rootScope._map.setZoom(10);
                }
                if (type === 'custom') {
                    $scope.customChanged = true;
                    $scope.makeSearchCall();
                } else if (type === 'filter') {
                    $scope.makeSearchCall();
                } else {
                    $location.path('-||-' + params(FacetMapService));
                }
            }
        };

        $scope.clearSearch = function (type) {
            $rootScope.$broadcast('showBodyLoading');
            FacetMapService[type] = '';
            var temp = $scope[type];
            $scope[type] = '';
            if (type === 'l' && ($.inArray('lv', FacetMapService.openFacetFields) !== -1)) {
                FacetMapService.openFacetFields.splice(FacetMapService.openFacetFields.indexOf('lv'), 1);
                delete FacetMapService.facetMap['lv'];
                $scope.latitude = '';
                FacetMapService.latitude = '';
                FacetMapService.longitude = '';
                $scope.longitude = '';
                $scope.locationSearch = null;
            }
            FacetMapService.page = 0;
            FacetMapService.searchNameOnly = false;
            FacetMapService.sort = '12';
            delete sortFilters['13'];
            $location.path('-||-' + params(FacetMapService));
            if (temp === '' || temp == null || temp === undefined)
                $rootScope.$broadcast('hideBodyLoading');
        };

        //watching for ajaxcall return values
        $scope.$on('facetedContactResults', function (ev, results) {
            $scope.customChanged = false;
            $scope.facets = results.facets;
            //logService($scope.facets);
            if (!($location.path() === '/' || $location.path() === '' || $location.path() === '//')) {
                updateFacetMap(FacetMapService, $location.path().split('-||-'));
            }

            openFacets();
            checkCheckboxes();
            editLocation();
            $scope.l = FacetMapService.l || '';
            $scope.kw = FacetMapService.kw || '';
            $scope.searchNameOnly = FacetMapService.searchNameOnly || false;
            if (FacetMapService.facetMap['lv'] == null) $scope.facets[0].checked = true;
            if (results.pipelineAndOperatorFacets) {
                $scope.andFacets.facets = results.pipelineAndOperatorFacets.split(',');
            }
            if (results.customFields) {
                angular.forEach(results.customFields, function (customField, key) {
                    if (customField.type === 'Select' || customField.type === 'Radio') {
                        var select2Values = [];
                        angular.forEach(customField.values, function (value, key) {
                            /*
                             * We are constructing the key and value pairs in the UI for Select and Radio custom field types. 
                             * This data is user entered text and there was a bug happening when the key was starting with a '$' symbol
                             * as this won't trigger the watch which in turn would make the search call with this custom field value.
                             * As a workaround, we are appending all the key names with this text: 'remove'
                             * And before making the search call, we are removing the added text.
                             * Refer to: https://jobvite.atlassian.net/browse/EN-3349
                             */
                            select2Values.push({
                                'key': 'remove' + value,
                                'value': value
                            });
                        });
                        customField.valueArray = select2Values;
                    } else if (customField.type === 'Check') {
                        customField.valueArray = [{
                            'key': 'true',
                            'value': i18n.YES
                        }, {
                            'key': 'false',
                            'value': i18n.NO
                        }];
                    }
                });
                if (!$scope.customFields || $scope.customChanged || $scope.resetSearch) {
                    $scope.customFields = results.customFields;
                    $scope.customChanged = false;
                    $scope.resetSearch = false;
                }
            }
            if ($scope.gdprEnabled && results.dataConsentStatus) {
                var select2Values = [];
                angular.forEach(results.dataConsentStatus, function (value, key) {
                    if (value && value.key && value.value) {
                        select2Values.push({
                            'key': value.key,
                            'value': value.value
                        });
                    }
                });
                $scope.dataConsentStatusField.valueArray = select2Values;
            }
        });

        $scope.$on('expandedFacetField', function (ev, results) {
            //$scope.facets = results.facets;
            for (var key in results.facets) {
                if (results.facets[key].facetValues.length !== 0) {
                    $scope.facets[key].checked = true;
                    //FacetMapService.openFacetFields.push($scope.facets[key].fieldId);
                    $scope.facets[key].facetValues = results.facets[key].facetValues;
                    $location.path('-||-' + params(FacetMapService));
                }
            }
        });

        $scope.$on('refresh', function () {
            $scope.$emit('filter', FacetMapService);
            //reset all checkboxes
            contactService.getMapping(FacetMapService, function () {
                contactService.searchContacts(FacetMapService);
            });
        });
        var openFacets = function () {
            if ($location.path() === '/' || $location.path() === '' || $location.path() === '//') {
                //console.log('if : '+ $location.path());
                FacetMapService.openFacetFields = [];
                angular.forEach($scope.facets, function (value, key) {
                    //console.log(value);
                    if (value.facetValues.length !== 0) {
                        FacetMapService.openFacetFields.push(value.fieldId);
                        value.checked = true;
                        value.showFacetValues = true;
                    }
                });
                //FacetMapService.openFacetFields.push('l');
            } else {
                //console.log('else : '+ $location.path());
                //When searching for the second time on contacts page using top nav search, this is needed.
                if ($location.path().indexOf('queryString') !== -1) {
                    setPathWithKeyword($location.path());
                } else {
                    FacetMapService.openFacetFields = $location.path().split('-||-')[2].split('-|-');
                    angular.forEach($scope.facets, function (value, key) {
                        //console.log(value.fieldId+' in '+FacetMapService.openFacetFields);
                        //console.log($.inArray(value.fieldId, FacetMapService.openFacetFields));
                        if ($.inArray(value.fieldId, FacetMapService.openFacetFields) !== -1) {
                            value.checked = true;
                            value.showFacetValues = true;
                        }
                    });
                }


            }
        };

        var checkCheckboxes = function () {
            angular.forEach($scope.facets, function (category, key) {
                if (category.fieldId in FacetMapService.facetMap) {
                    category.checked = true;
                    //category.more = FacetMapService.facetMap[category.fieldId].more;
                    angular.forEach(category.facetValues, function (value, key2) {
                        if (contains(value.value, FacetMapService.facetMap[category.fieldId].values)) {
                            //console.log(value.value+' is in '+FacetMapService.facetMap[category.fieldId] );
                            value.checked = true;
                            category.checked = false;
                            //console.log(category);

                            // Note the special logic to show 10 tags per page instead of 5, unlike the other facets

                            var startPos = constantService.FACET_PAGE_SIZE - 1;
                            var endPos = constantService.FACET_PAGE_SIZE * 2;
                            if (category.fieldId === 't') {
                                startPos = (constantService.FACET_PAGE_SIZE * 2) - 1;
                                endPos = endPos * 2;
                            }
                            if (!category.more && (key2 > startPos) && (key2 < endPos)) {
                                category.more = true;
                                //FacetMapService.facetMap[category.fieldId].more = true;
                            }
                        }
                    });
                }
            });
        };

        var contains = function (val, list) {
            var result = false;
            angular.forEach(list, function (value, key) {
                if (val === value) result = true;
            });
            return result;
        };

        //closing and opening the filter
        $scope.closeFilter = closeFilter;
        $scope.openFilter = openFilter;

        var resetSelectionComplianceValues = function () {
            $scope.dataConsentStatusField.selectedValue = '';
            $scope.dataConsentDateField.selectedValue = '';
            $scope.autoDeletionDateField.selectedValue = '';

            $scope.dataConsentStatusField.hideValues = false;
            $scope.dataConsentDateField.hideValues = false;
            $scope.autoDeletionDateField.hideValues = false;
        };

        //reset
        $scope.reset = function () {
            //updateFacetMap(FacetMapService,'/');
            $scope.kw = '';
            $scope.l = '';
            delete sortFilters['13'];
            $location.path('');
            if ($scope.customFields) {
                $scope.resetSearch = true;
                FacetMapService.customFiltersString = [];
            }
            if ($scope.gdprEnabled) {
                resetSelectionComplianceValues();
                $scope.makeSearchCall();
            }
        };

        //save search - still need to hook up to backend (in contactService.js)
        $scope.saveSearch = function () {
            //console.log($location.path().split('/')[1]);
            modalService.saveSearch();
        };

        $scope.$on('saveSearch', function (ev, results) {
            const args = {};
            args.name = results;
            args.url = $location.path();
            contactService.saveSearch(args, function () {
                JV.showDropDownMessage(constantService.SAVED_SEARCH);
            });
        });

        //select a saved search
        $scope.selectSearch = function () {
            modalService.selectSavedSearch();
        };

        $scope.$on('selectSearch', function (ev, results) {
            $location.path('' + results);
        });

        //when a checkbox is checked or unchecked
        $scope.check = function (facetCategory, facetValue, showLoading) {
            if (showLoading === true) $rootScope.$broadcast('showBodyLoading');
            //console.log(facetCategory);
            addFacet(FacetMapService, facetCategory, facetValue);
            FacetMapService.page = 0;

            //google analytics
            if (typeof _gaq !== 'undefined') {
                _gaq.push(['_trackEvent', JV.PAGE_TYPE, 'facetedSearch-checkFacet' + facetCategory + ':' + facetValue, _jvselfUser.companyEId]);
            }

            $location.path('-||-' + params(FacetMapService));
        };

        $scope.checkParent = function (category) {
            //console.log(category.checked);
            if (!category.checked) {
                category.checked = true;
            } else {
                FacetMapService.page = 0;
                $rootScope.$broadcast('showBodyLoading');
                delete FacetMapService.facetMap[category.fieldId];
                $location.path('-||-' + params(FacetMapService));
            }
            FacetMapService.page = 0;
        };

        $scope.explode = function (category) {
            category.more = !category.more;
            //FacetMapService.facetMap[category.fieldId].more = category.more;
        };

        $scope.expandCategory = function (category) {
            //VA: show the loading state as the watch is on facetValues null value.
            category.showFacetLoading = true;
            //$rootScope.$broadcast('showBodyLoading');
            //console.log(category);
            category.showFacetValues = !category.showFacetValues;
            category.checked = true;
            FacetMapService.singleFacet = category.fieldId;
            if (FacetMapService.openFacetFields.length === 1 && FacetMapService.openFacetFields[0] === '') {
                FacetMapService.openFacetFields[0] = category.fieldId;
            } else FacetMapService.openFacetFields.push(category.fieldId);
            contactService.getMapping(FacetMapService, function () {
                category.showFacetLoading = false;
                $rootScope.$broadcast('hideBodyLoading');
                contactService.openFacet(FacetMapService);
            });
            // FacetMapService.openFacetFields.push(category.fieldId);
            // $location.path('/'+params(FacetMapService));
        };

        $scope.minimizeCategory = function (category) {
            //console.log(category);
            $rootScope.$broadcast('showBodyLoading');
            category.showFacetValues = !category.showFacetValues;
            $scope.checkParent(category);
            //console.log(FacetMapService.openFacetFields.length);
            if (FacetMapService.openFacetFields.indexOf(category.fieldId) !== -1) {
                FacetMapService.openFacetFields.splice(FacetMapService.openFacetFields.indexOf(category.fieldId), 1);
                // console.log(FacetMapService.facetMap[category.fieldId] == undefined);

                //google analytics
                if (typeof _gaq !== 'undefined') {
                    _gaq.push(['_trackEvent', JV.PAGE_TYPE, 'facetedSearch-openFacet' + category, _jvselfUser.companyEId]);
                }

                if (FacetMapService.facetMap[category.fieldId] == undefined) $rootScope.$broadcast('hideBodyLoading');
                delete FacetMapService.facetMap[category.fieldId];
                $location.path('-||-' + params(FacetMapService));
            }
        };

        $scope.expandCollapseCustomField = function (customField) {
            customField.hideValues = !customField.hideValues;
        };

        $scope.expandCollapseField = function (field) {
            field.hideValues = !field.hideValues;
        };


        $scope.minorexp = function (category) {
            if (category.showFacetValues)
                $scope.minimizeCategory(category);
            else
                $scope.expandCategory(category);
        };

        //extra location code
        $scope.locationCheck = true;

        $scope.minMaxLocation = function () {
            $scope.showLocation = !$scope.showLocation;
            if ($scope.showLocation) {
                $scope.clearSearch('l');
            }
        };

        //location Radius Search

        $scope.showLocationValues = false;
        $scope.locationNotFound = false;
        var editLocation = function () {
            $scope.showLocationValues = $scope.facets[0].facetValues.length > 0 && FacetMapService.facetMap['lv'] !== undefined;
            $scope.locationNotFound = $scope.facets[0].facetValues.length === 0 && FacetMapService.facetMap['lv'] !== undefined;
            angular.forEach($scope.facets[0].facetValues, function (value, key) {
                value.valueDisplayName = value.valueDisplayName + ' (' + value.count + ')';
                if (FacetMapService.facetMap['lv'] !== undefined && FacetMapService.facetMap['lv'].values[0] === value.value) {
                    $scope.locationSearch = value;
                }
            });
        };

        $scope.showAdvancedSettings = function () {
            $scope.andFacets.allFacets = $scope.facets;
            modalService.advancedSettings($scope.andFacets);
        };

        $scope.operatorText = function (facet, category) {
            if (!facet.checked) {
                return;
            }
            return ($scope.andFacets.facets.indexOf(category.fieldId) > -1 ? 'and' : 'or');
        };

        $scope.locationSearch = null;
        $scope.$watch('locationSearch', function (newValue, oldValue) {
            if (newValue && oldValue && angular.equals(newValue.checked, oldValue.checked)) {
                return;
            }
            if ($scope.locationSearch !== null && $scope.facets !== undefined) {
                delete FacetMapService.facetMap['lv'];
                $scope.check($scope.facets[0].fieldId, $scope.locationSearch.value, false);
            }
        });

        $scope.generateFilterValues = function (values) {
            var select2Values = [];
            angular.forEach(values, function (value, key) {
                select2Values.push({
                    'value': value,
                    'valueDisplayName': value
                });
            });
            return select2Values;
        };

        //Select2Service
        $scope.autoComplete = function (categoryId) {
            //console.log('hello');
            var url = jvUrls.source + '/action/crm/facetedsearch/facetsearch';
            var encodeHtml = $filter('noHTML');

            var config = {
                id: 'EId',
                ajax: {
                    quietMillis: 750,
                    url: url,
                    data: function (term) {
                        return {
                            fieldId: categoryId,
                            prefix: term
                        };
                    },
                    results: function (data) { // parse the results into the format expected by Select2.
                        // since we are using custom formatting functions we do not need to alter remote JSON data
                        return {
                            results: data.facets[0].facetValues
                            //more: more
                        };
                    }
                },
                formatResult: function (data) {
                    //console.log(data);
                    if (data.valueDisplayName == null)
                        return encodeHtml(data.value);
                    else return encodeHtml(data.valueDisplayName);
                },
                formatSelection: function (data) {
                    //console.log(data);
                    if (data.valueDisplayName == null)
                        return encodeHtml(data.value);
                    else return encodeHtml(data.valueDisplayName);
                },
                id: function (data) {
                    return data;
                }
            };
            return config;
        };
    }
]);

/**
 * Grid Header Controller
 */
AppCtrlModule.controller('ContactHeaderCtrl', ['$rootScope', '$scope', 'contactService', 'FacetMapService', 'logService', '$location', 'modalService', '$window', 'constantService', '$q', 'TemplateLoader',
    function ($rootScope, $scope, contactService, FacetMapService, logService, $location, modalService, $window, constantService, $q, TemplateLoader) {
        //actions
        //pagination

        $rootScope.mapEnable = mapEnable || false;

        if ($rootScope.mapEnable) {
            var mapOptions = {
                center: new google.maps.LatLng(37.339085, -121.8914807),
                zoom: 2,
                mapTypeId: 'roadmap',
                disableDefaultUI: true,
                minZoom: 5,
                mapTypeControl: false,
                streetViewControl: false
            };
            $rootScope._map = new google.maps.Map(document.getElementById('map3d'), mapOptions);

            google.maps.event.addListener($rootScope._map, 'dragend', function () {
                //              console.log($rootScope._map.getZoom());
                if (FacetMapService) {
                    FacetMapService.latitude = $rootScope._map.getCenter().lat();
                    FacetMapService.longitude = $rootScope._map.getCenter().lng();
                    FacetMapService.maxResults = 500;

                    var x1y1 = $rootScope._map.getBounds().getNorthEast();
                    var x2y2 = $rootScope._map.getCenter();

                    var y2 = x2y2.lng();
                    var x2 = x2y2.lat();
                    var y1 = x1y1.lng();
                    var x1 = x1y1.lat();

                    var distance = Math.sqrt(((y2 - y1) * (y2 - y1)) + ((x2 - x1) * (x2 - x1)));
                    FacetMapService.facetMap['lv'] = {};
                    FacetMapService.facetMap['lv'].values = ['0-' + Math.floor(distance * 69)];

                    $location.path('-||-' + params(FacetMapService));
                }
            });

            function _successShow(instance) {
                ge = instance;
                ge.getWindow().arguments.setVisibility(true);
            }

            function _fail() {

            }
        }

        $scope.$on('facetedContactResults', function (ev, results) {
            $scope.total = results.resultCount;
            $scope.hideSelectMsg = true;
            if ($location.path() === '/' || $location.path() === '' || $location.path() === '//') {
                $scope.end = results.resultList.length;
                $scope.start = 1;

                $scope.currentSorter = $scope.contactSortFilters['12'];
            } else {
                // results.pageCount = 50;
                const page = FacetMapService.page;
                $scope.end = results.resultList.length + results.pageCount * page;
                $scope.start = results.pageCount * page + 1;
                if ($scope.end > results.resultCount) $scope.end = results.resultCount;

                $scope.currentSorter = $scope.contactSortFilters[FacetMapService.sort];
                //console.log( $scope.contactSortFilters[FacetMapService.sortKey]);
            }

            $scope.$emit('totalCount', results.resultCount);

            if (results.contactStatuses) {
                $scope.contactStatuses = results.contactStatuses;
            }
        });

        $scope.addToCampaignButton = (JV.campaignEid && JV.campaignEid.trim() !== '');
        if ($scope.addToCampaignButton) {
            $scope.addToCampaign = function () {
                var args = {};
                args.eid = JV.campaignEid;
                if (_selectedEids.length > 0) {
                    $scope.hideSelectMsg = true;
                    $rootScope.$broadcast('showBodyLoading', true);
                    $scope.currentPerformActionFilter.key = 'campaign';
                    $scope.$broadcast('addToCampaign', args);
                } else {
                    $scope.hideSelectMsg = false;
                }
            };
        }

        // Sort Actions
        $scope.contactSortFilters = sortFilters;

        // Set Max Results Filter
        $scope.contactMaxResultsFilters = maxResultsFilters;

        $scope.setSort = function (sortNumber) {
            if (FacetMapService.sort !== sortNumber) $rootScope.$broadcast('showBodyLoading');
            $scope.currentSorter = $scope.contactSortFilters[sortNumber];
            FacetMapService.sort = sortNumber;
            //console.log($scope.contactSortFilters[sorftNumber].key);
            if (!$scope.sortDropDown)
                $scope.sortDropDown = !$scope.sortDropDown;
            $location.path('-||-' + params(FacetMapService));
        };

        $scope.setMaxResults = function (maxResults) {
            $scope.currentMaxResults = $scope.contactMaxResultsFilters[maxResults];
            if (FacetMapService.maxResults !== $scope.currentMaxResults.text) {
                $rootScope.$broadcast('showBodyLoading');
                FacetMapService.maxResults = $scope.currentMaxResults.text;
                FacetMapService.page = 0;
                if (!$scope.maxResultsDropDown)
                    $scope.maxResultsDropDown = !$scope.maxResultsDropDown;
                $location.path('-||-' + params(FacetMapService));
            }
        };

        //action Actions
        $scope.performActionFilter = actionFilters;
        $scope.currentPerformActionFilter = {};
        $scope.hideSelectMsg = true;
        var _selectedEids = [];
        var _selectedContacts = [];

        $scope.$on('uncheckAll', function () {
            $scope.$applyAsync(function() {
                _selectedEids = [];
                _selectedContacts = [];
            });
        });

        $scope.$on('contactSelected', function (event, result) {
            _selectedEids = result.eids;
            _selectedContacts = result.contacts;
            //hiding error message when checkboxes are checked
            $scope.hideSelectMsg = true;
        });


        $scope.$on('sendAMessage', function (event, result) {
            // _selectedEids = result.EId;
            // _selectedContacts = result;
            actionFilters.some(function (action, index) {
                if (action.key === 'message') {
                    $scope.performAction(index);
                    return true;
                }
            });
        });

        $scope.performAction = function (actionNumber) {
            $scope.actionDropDown = false;
            $scope.currentPerformActionFilter = $scope.performActionFilter[actionNumber];
            //console.log(_selectedEids);
            if (_selectedEids.length > 0) {
                $scope.hideSelectMsg = true;
                performAction();
            } else {
                $scope.hideSelectMsg = false;
            }
        };

        function performAction() {
            //contactService.noOfContacts = _selectedEids.length;
            //contactService.selectedEids = _selectedEids;
            if ($scope.currentPerformActionFilter.key === 'note') {
                modalService.addNote();
            }
            if ($scope.currentPerformActionFilter.key === 'campaign') {
                modalService.selectCampaign();
            }
            if ($scope.currentPerformActionFilter.key === 'req') {
                modalService.selectRequisition();
            }
            if ($scope.currentPerformActionFilter.key === 'task') {
                modalService.addTask(_selectedEids);
            }
            if ($scope.currentPerformActionFilter.key === 'assign') {
                modalService.assignTo(_selectedEids);
            }
            if ($scope.currentPerformActionFilter.key === 'status') {
                modalService.changeStatus({
                    selected: _selectedEids,
                    statuses: $scope.contactStatuses
                });
            }
            if ($scope.currentPerformActionFilter.key === 'tag') {
                //VA: assuming that _selectedContacts was created to keep track of the selected contacts.
                modalService.addTag(_selectedEids);
            }
            if ($scope.currentPerformActionFilter.key === 'message') {
                var hasEmail = false;
                angular.forEach(_selectedContacts, function (value, key) {
                    if (!hasEmail) {
                        hasEmail = (value.primaryEmail !== null && (value.primaryEmail.name !== '' && value.primaryEmail.name !== null));
                    }
                });
                if (!hasEmail) {
                    JV.showDropDownMessageError(constantService.EMAIL_ERROR);
                } else {
                    contactService.messageEids = _selectedEids;
                    modalService.addMessage();
                }
            }
            // GDPR - SEEK_CONSENT
            if ($scope.currentPerformActionFilter.key === 'seekConsent') {
                var hasEmail = false;
                angular.forEach(_selectedContacts, function (value, key) {
                    if (!hasEmail) {
                       hasEmail = (value.primaryEmail !== null && (value.primaryEmail.name !== '' && value.primaryEmail.name !== null));
                    }
                });
                if (!hasEmail) {
                    JV.showDropDownMessageError(constantService.EMAIL_ERROR);
                } else {
                    contactService.messageEids = _selectedEids;
                    modalService.addSeekConsentMessage();
                }
            }
            //jobvite
            if ($scope.currentPerformActionFilter.key === 'jobvite') {
                var hasEmail = false;
                angular.forEach(_selectedContacts, function (value, key) {
                   if (!hasEmail) {
                       hasEmail = (value.primaryEmail !== null && (value.primaryEmail.name !== '' && value.primaryEmail
                       .name !== null));
                   }
                });
                if (!hasEmail) {
                    JV.showDropDownMessageError(constantService.EMAIL_ERROR);
                } else {
                    var emails = [];
                    var referrer = '/contact2/contactList.html#' + $location.path();
                    angular.forEach(_selectedContacts, function (value, key) {
                        if (value.primaryEmail !== null && value.primaryEmail.name && value.primaryEmail.name.trim() !== '')
                            emails.push(value.primaryEmail.name);
                    });
                    contactService.shareJobvite(referrer, emails);
                }
            }
            //merge
            if ($scope.currentPerformActionFilter.key === 'merge') {
                if (_selectedEids.length < 2) {
                    JV.showDropDownMessageError(constantService.MERGE_ERROR);
                } else {
                    //console.log(contactService.getUrl('merge', _selectedEids));
                    $window.location.href = contactService.getUrl('merge', _selectedEids);
                }
            }
            //export
            if ($scope.currentPerformActionFilter.key === 'export') {
                $window.location.href = contactService.getUrl('export', _selectedEids);
                JV.showDropDownMessage(constantService.EXPORT_SUCCESSFUL.format(_selectedEids.length));
                $rootScope.$broadcast('uncheckAll');
            }

            //delete
            if ($scope.currentPerformActionFilter.key === 'delete') {
                contactService.deleteEids = _selectedEids
                modalService.deleteContacts();
            }

            // add bulk to requisition
            if ($scope.currentPerformActionFilter.key === 'addContactsToReqs') {
                //TODO: add logic to popup requisition modal.
                contactService.getReqsFilters(function (result) {
                    modalService.addToReq(result);
                });
            }

        }

        //listening to modals
        $scope.$on('addNote', function (ev, results) {
            //console.log(results);
            completeAction(results, function () {
                JV.showDropDownMessage(constantService.NOTE_ADDED.format(contactService.selectedEidslength));
            });
        });


        $scope.$on('addTag', function (ev, results) {
            completeAction(results, function () {
                JV.showDropDownMessage(constantService.TAG_ADDED.format(contactService.selectedEidslength));
            });
        });

        $scope.$on('addMessage', function (ev, results) {
            completeAction(results, function () {
                JV.showDropDownMessage(constantService.MESSAGE_SENT.format(contactService.selectedEidslength));
            });
        });

        $scope.$on('addSeekConsentMessage', function (ev, results) {
            completeAction(results, function () {
                JV.showDropDownMessage(constantService.MESSAGE_SENT.format(contactService.selectedEidslength));
            });
        });

        $scope.$on('addToCampaign', function (ev, results) {
            completeAction(results, function (response) {
                var message = (response && response.data) ? response.data : null;
                $rootScope.$broadcast('hideBodyLoading', true);
                if (results.name == null || results.name === undefined) results.name = 'the campaign';
                JV.showDropDownMessage(message || constantService.ADDED_TO_CAMPAIGN.format(contactService.selectedEidslength, results.name));
            });
        });

        $scope.$on('addToRequisition', function (ev, results) {
            //console.log(results);
            completeAction(results, function () {
                //JV.showDropDownMessage(constantService.ADDED_TO_CAMPAIGN.format(contactService.selectedEidslength, results.title));
            });
        });

        $scope.$on('REQUISITTION_SELECTED_ID', function (ev, results) {
            var reqName = '';
            // get the title of the requisition.
            for (var i = 0, j = results.allItems.length; i < j; i++) {
                if (results.allItems[i].EId === results.selectedReqEId) {
                    reqName = results.allItems[i].title;
                    break;
                }
            }
            var obj = [];
            obj.push(results.selectedReqEId);
            var newObj = {
                ids: obj
            };
            //console.log(results);
            //Need to add page loading image
            //console.log(results);
            //        $rootScope.$broadcast('showBodyLoading');
            //        completeAction(newObj, function(result){
            //        debugger;
            //        $rootScope.$broadcast('hideBodyLoading');
            completeAction(newObj, function (result) {
                const data = result.data;
                //result.sync = true;
                if (result != null && !!result.status && result.status === 200 && data.sync !== undefined) {
                    data.reqName = reqName;
                    modalService.addtoReqConfirm(data);
                }
            });
        });

        function completeAction(message, callback) {
            //console.log(message);
            contactService.performAction({
                'eids': _selectedEids,
                'action': $scope.currentPerformActionFilter.key,
                'content': message,
                'reqId': message.EId,
                'jobIds': message.ids
            }, function (res) {
                callback(res);
            });
        }
        $rootScope.$on('DOCUMENT_CLICK', function () {
            $scope.sortDropDown = false;
        });

        // togglers
        $scope.toggleSorters = function () {
            $scope.sortDropDown = !$scope.sortDropDown;
        };
        $scope.toggleActions = function () {
            $scope.actionDropDown = !$scope.actionDropDown;
        };
        var _scope = $scope;

        //Global event to let the controller know that it needs to close the drop downs.
        $scope.$on('closeDropDown', function (event, results) {
            $scope.actionDropDown = false;
        });

        //pagination
        $scope.paginate = function (next) {
            const page = FacetMapService.page;
            if (next && $scope.total > $scope.end) {
                $rootScope.$broadcast('showBodyLoading');
                FacetMapService.page++;
            }
            if (!next && page > 0) {
                $rootScope.$broadcast('showBodyLoading');
                FacetMapService.page--;
            }
            $location.path('-||-' + params(FacetMapService));
            _selectedEids = [];
            _selectedContacts = [];
        };
    }
]);

/**
 * Grid Body Controller
 */
AppCtrlModule.controller('ContactGridCtrl', ['$scope', 'contactService', 'logService', '$rootScope', 'FacetMapService', '$compile',
    function ($scope, contactService, logService, $rootScope, FacetMapService, $compile) {
        $scope.getMilliseconds = function (dateVal) {
            if (dateVal) {
                var d = new Date(dateVal);
                return d.getTime();
            }
        };

        $scope.selectedEids = [];
        $scope.selectedContacts = [];
        $rootScope._markers = [];
        $rootScope._markerMap = {};
        var totalCount = 0;
        $scope.showAddToCampaignMessage = false;
        $scope.campaignPage = (JV.campaignEid && JV.campaignEid.trim() !== '');

        $scope.contactDetails = function (entityId, event) {
            if (event) {
                event.preventDefault();
            }
            contactService.getContactDetailIds(FacetMapService, function (results) {
                contactService.postToContactDetails({
                    'ids': entityId,
                    'contactIds': results.data.resultList,
                    'totalContactIds': totalCount
                });
            });
        };

        //grid display and manipulation
        $scope.$on('facetedContactResults', function (ev, results) {
            totalCount = results.resultCount;
            $scope.gridResults = results.resultList;
            $scope.showBodyLoading = false;
            determineDots();
            if (FacetMapService && FacetMapService.latitude && FacetMapService.longitude) {
                //              addMarkers();
            }
            if ($rootScope.mapEnable) {
                addMarkers();
            }
            //logService($scope.gridResults);
            $scope.checkAllchecked = false;
            $scope.selectedEids = [];
            $scope.selectedContacts = [];
        });

        // //unchecking all after modal closes - doesnt work.
        $scope.$on('uncheckAll', function () {
            for (var i = 0; i < $scope.selectedEids.length; i++) {
                $scope.addCheck($scope.selectedEids[i]);
                $scope.addCheck($scope.selectedContacts[i]);
            }

            $scope.selectedEids = [];
            $scope.selectedContacts = [];

            $rootScope.$broadcast('refresh');
        });

        $scope.$on('showBodyLoading', function (event, message) {
            $scope.showBodyLoading = true;
            if (message && $scope.campaignPage) {
                $scope.showAddToCampaignMessage = true;
            }
        });

        $scope.$on('hideBodyLoading', function (event, message) {
            $scope.showBodyLoading = false;
            if (message && $scope.campaignPage) {
                $scope.showAddToCampaignMessage = false;
            }
        });

        var roundUpCoordinates = function (val) {
            //      var temp = Math.round(val*10000000);
            //      return temp/10000000;
            return val;
        };

        var addMarkers = function () {
            if (FacetMapService.longitude || FacetMapService.latitude) {
                $rootScope._map.setCenter(new google.maps.LatLng(FacetMapService.latitude, FacetMapService.longitude));
            }

            angular.forEach($rootScope._markers, function (value, key) {
                $rootScope._markers[key].setMap(null);
            });
            $rootScope._markers.length = 0;

            if ($rootScope._markers) {
                for (var i in $rootScope._markers) {
                    google.maps.event.clearInstanceListeners($rootScope._markers[i]);
                }
            }

            $rootScope._markerMap = {};
            angular.forEach($scope.gridResults, function (value, key) {
                if (value.primaryAddress) {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(roundUpCoordinates(value.primaryAddress.latitude), roundUpCoordinates(value.primaryAddress.longitude)),
                        animation: google.maps.Animation.DROP
                    });

                    $rootScope._markers.push(marker);
                    $rootScope._markerMap[marker.position.lat() + '' + marker.position.lng()] = $rootScope._markerMap[marker.position.lat() + '' + marker.position.lng()] || [];
                    $rootScope._markerMap[marker.position.lat() + '' + marker.position.lng()].push(value);

                    google.maps.event.addListener(marker, 'click', (function (marker, $scope) {
                        return function () {

                            var contacts = $rootScope._markerMap[marker.position.lat() + '' + marker.position.lng()];

                            $scope.openContact = function (entityId) {
                                $scope.contactDetails(entityId);
                                //Need to add page loading image
                            };

                            var createInfoWindow = function (contacts, marker) {
                                var content = '';
                                for (var index in contacts) {
                                    content += '<p><a class="infoWindowData" ng-click="openContact(\'' + contacts[index].EId.toString() + '\')">' + contacts[index].firstName + '&nbsp;' + contacts[index].lastName + '</a></p>';
                                }

                                var infowindow = new google.maps.InfoWindow({
                                    content: content,
                                    maxWidth: 400
                                });

                                google.maps.event.addListener(infowindow, 'domready', function () {
                                    $scope.$apply(function () {
                                        $compile($('.infoWindowData'))($scope);
                                    });
                                });

                                infowindow.open($rootScope._map, marker);

                            };

                            createInfoWindow(contacts, marker);
                        };
                    })(marker, $scope));
                }
            });

            var mcOptions = {
                gridSize: 50,
                maxZoom: 15,
                center: new google.maps.LatLng(FacetMapService.latitude, FacetMapService.longitude)
            };

            if ($rootScope._markerCluster) {
                $rootScope._markerCluster.clearMarkers();
            }
            $rootScope._markerCluster = new MarkerClusterer($rootScope._map, $rootScope._markers, mcOptions);
        };

        //email dots and company/title dots
        var determineDots = function () {
            // OPT_IN("Has Not Opted Out"), LIMITED("Limited"), UNSUBSCRIBED("Opted Out")
            angular.forEach($scope.gridResults, function (value, key) {
                value.orange = (value.notifyPref === 'LIMITED' && value.primaryEmail !== null && value.primaryEmail.name !== '');
                value.red = (value.notifyPref === 'UNSUBSCRIBED' && value.primaryEmail !== null && value.primaryEmail.name !== '');
                value.redBounce = (value.notifyPref && value.notifyPref.startsWith('BOUNCE') && value.primaryEmail !== null && value.primaryEmail.name !== '');
                //value.green = (value.notifyPref == 'OPT_IN' && value.primaryEmail !==null && value.primaryEmail.name !== '');
                if (!value.orange && !value.red && !value.redBounce && value.primaryEmail !== null && value.primaryEmail.name !== '') value.green = true;
                value.showDot = (value.companyName !== null && value.jobTitle !== null && value.companyName !== '' && value.jobTitle !== '');
            });
        };

        $scope.checkAll = function () {
            if ($scope.checkAllchecked) {
                $rootScope.$broadcast('checkAll');
                angular.forEach($scope.gridResults, function (value, key) {
                    var inArray = $.inArray(value.EId, $scope.selectedEids);
                    if (inArray == -1) {
                        $scope.addCheck(value, value.EId);
                        value.checked = true;
                    }
                });
                $rootScope.$broadcast('checkAll', $scope.selectedEids);
            } else {

                $rootScope.$broadcast('uncheckAll');
                $scope.selectedEids = [];
                $scope.selectedContacts = [];
                angular.forEach($scope.gridResults, function (value, key) {
                    value.checked = false;
                });
                broadcastContacts();
            }
        }

        $scope.addCheck = function (entity, eid) {
            //console.log(eid);
            var inArray = $.inArray(eid, $scope.selectedEids);
            if (inArray == -1) {
                //add
                $scope.selectedEids.push(eid);
                $scope.selectedContacts.push(entity);
            } else {
                //remove
                $scope.selectedEids.splice(inArray, 1);
                $scope.selectedContacts.splice(inArray, 1);
            }
            broadcastContacts();
        }

        function broadcastContacts() {
            var passingObject = {};
            passingObject.eids = $scope.selectedEids;
            passingObject.contacts = $scope.selectedContacts;
            $rootScope.$broadcast('contactSelected', passingObject);
        }

        //send message
        $scope.sendMessage = function (entity, eid) {
            $scope.addCheck(entity, eid);
            $rootScope.$broadcast('sendAMessage');
        }
    }
]);